// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper {
  padding: 20px;
  background-color: #ffffff;
  margin: 40px;
}

.cell-width {
  min-width: 50px;
  width: 50px;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
}

.value-cell {
  background-color: transparent;
  height: 100%;
  width: 100%;
  font-size: 0.9rem;
}

.category-cell {
  min-width: 150px;
  width: 150px;
  padding: 2px 10px;
  font-weight: bold;
  text-align: left;
  display: flex;
  align-items: center;
}
.category-cell .category-icon {
  display: none;
}

.table-container {
  overflow-x: auto;
  overflow-y: hidden;
  background: white;
  border: 1px solid #e0e0e0;
  position: relative;
  z-index: 0;
  isolation: isolate;
}
.table-container::-webkit-scrollbar {
  height: 10px;
}
.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  margin-left: 150px;
}
.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}
.table-container table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}
.table-container table th, .table-container table td {
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.table-container table tr.mat-mdc-row:nth-child(even) {
  background-color: #f9f9f9;
}
.table-container table tr.mat-mdc-row:nth-child(even) td.mat-column-category {
  background-color: #f9f9f9 !important;
}
.table-container table tr.mat-mdc-row:hover {
  background-color: #eceff1 !important;
}
.table-container table tr.mat-mdc-row:hover td.mat-column-category {
  background-color: #eceff1 !important;
}
.table-container .mat-mdc-header-row {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}
.table-container tr.mat-mdc-header-row:nth-child(2) {
  top: 40px;
  z-index: 11;
}
.table-container tr.mat-mdc-header-row:nth-child(2) .mat-mdc-header-cell {
  background-color: #eeeeee !important;
  color: #555555;
}
.table-container .mat-column-category, .table-container .category-sticky-header {
  position: sticky;
  left: 0;
  background-color: white !important;
  z-index: 12 !important;
  border-right: 5px solid #03a9f4 !important;
}
.table-container th.mat-column-month-header-first {
  z-index: 15 !important;
  top: 0;
}
.table-container .month-cell {
  background-color: #03a9f4 !important;
  color: white;
  border-right: 1px solid white !important;
  text-align: center;
  font-weight: bold;
  height: 40px;
}
.table-container .cell-width[style*=background-color] {
  color: white !important;
  font-weight: bold;
  border-radius: 0 !important;
  height: 100% !important;
  width: 100% !important;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.mat-mdc-table {
  background: white;
}

.mdc-data-table__cell,
.mdc-data-table__header-cell {
  padding: 0 !important;
  height: 40px !important;
}

::ng-deep .mat-progress-spinner, ::ng-deep .mat-spinner {
  z-index: 9999 !important;
}

@media only screen and (max-width: 840px) {
  .table-wrapper {
    padding: 10px;
    margin: 0px;
  }
  .category-cell {
    min-width: 60px;
    width: 60px;
    justify-content: center;
  }
  .category-cell .category-text {
    display: none !important;
  }
  .category-cell .category-icon {
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-size: 32px !important;
    width: 32px !important;
    height: 32px !important;
    line-height: 32px !important;
  }
  .category-cell .category-icon.arrival-icon {
    color: #779a34 !important;
  }
  .category-cell .category-icon.departure-icon {
    color: #f35870 !important;
  }
  .category-cell .category-icon.stay-icon {
    color: #85b0ec !important;
  }
  .category-cell .category-icon.dayuse-icon {
    color: #fbc02d !important;
  }
  .table-container::-webkit-scrollbar-track {
    margin-left: 60px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
